import React from "react";
import { connect, useSelector } from "react-redux";
import PageWrapper from "../../lib/page-wrapper";
import { Grid, Row, Col } from "react-bootstrap";
import partial from "lodash/partial";
import { AUDIO_BLOCK_CREATE_MODAL } from "../../modals/modal_root";
import { showModal } from "../../../actions/modal";
import { getAudioBlocksForUser, deleteAudioBlock } from "../../../action_managers/audio_management";
import { If } from "react-extras";
import isEmpty from "lodash/isEmpty";
import { withRouter } from "react-router";
import AudioBlocksTable from "./audio_blocks_table";
import map from "lodash/map";
import ExternalLink from "../../lib/external_link";
import { useComponentDidMount } from "../../../lib/hook";

const AudioBlocksPage = props => {
  const isLoading = useSelector(state => state.audioBlocks.isLoading);

  useComponentDidMount(() => {
    props.getAudioBlocksForUser(props.user);
  }, []);

  const audioBlocks = map(props.audioBlocks);
  return (
    <PageWrapper
      backLink={"/dynamic-insertion"}
      title={"Audio Blocks"}
      dividerMarginBottom={"0px"}
      topRightElement={() => {
        return (
          <div
            className="fake-link"
            onClick={() => {
              props.history.push("/audio-blocks/create");
            }}>
            New Audio Block
          </div>
        );
      }}>
      <Grid fluid>
        <If condition={!audioBlocks.length && !isLoading}>
          <Row className="audio-management-page__empty-state-container">
            <Col xs={12} md={8} mdOffset={2}>
              <div className={"text-center"}>
                Audio blocks are collections of audio that RedCircle can insert into your podcast
                episodes. Simply create a block, and it can be assigned to insertion points in your
                episodes.
                <div>
                  <ExternalLink
                    href={"https://support.redcircle.com/en/articles/3454588-audio-blocks"}
                    className="bold">
                    Learn More
                  </ExternalLink>
                </div>
              </div>
            </Col>
            <Col xs={4} xsOffset={4}>
              <button
                className="btn btn-primary audio-management__new-entity-btn"
                onClick={props.showModal}>
                New Audio Block
              </button>
            </Col>
          </Row>
        </If>
        <If condition={!isEmpty(props.audioBlocks)}>
          <Row>
            <Col xs={12} md={12}>
              <AudioBlocksTable audioBlocks={audioBlocks} />
            </Col>
          </Row>
        </If>
      </Grid>
    </PageWrapper>
  );
};

export default connect(
  state => ({ user: state.user.user, audioBlocks: state.audioBlocks.audioBlocks }),
  {
    showModal: partial(showModal, AUDIO_BLOCK_CREATE_MODAL),
    getAudioBlocksForUser,
    deleteAudioBlock,
  }
)(withRouter(AudioBlocksPage));
